import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './locales/en.json';
import zhCN from './locales/zh-CN.json';
import { DEFAULT_LOCALE, resolveInitialLocale } from './locales';

Vue.use(VueI18n);

// A plain singleton so non-component modules can translate too.
// Must not import @/store: that would create a cycle.
const i18n = new VueI18n({
  locale: resolveInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  silentFallbackWarn: true,
  messages: {
    en,
    'zh-CN': zhCN,
  },
});

export default i18n;
